define([
	"dojo/_base/declare",
	"./Actual",
	"./ActualGapMixin"
], function(declare,Actual,ActualGapMixin) {

	return declare([ActualGapMixin, Actual], {
		highlightSetting: "sizeChartHighlightDeltaOutOfTolerance",

		_getActual: function(/*Context*/ctx) {
			// summary: return actual value
			return ctx.getNode().Actuals[ctx.keyValue];
		},
		
		_getDiff: function(/*Number*/value, /*Number*/target) {
			// summary: return value since it is already the difference
			return value;
		},
		
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			return this._getValueGap(ctx);
		}
	});
});